import { Link } from "react-router-dom";
import { all_routes } from "../router/all_routes";
const FlashPanel = () => {
  const route = all_routes;
  return (
    <div>
      <>
        {/* Page Wrapper */}
        <div className="page-wrapper">
          <div className="content">
            <div className="row">
              <div className="col-md-12">
                {/* Page Header */}
                <div className="page-header">
                  <div className="row align-items-center">
                    <div className="col-8">
                      <h4 className="page-title">
                        Flash Panel<span className="count-title">123</span>
                      </h4>
                    </div>
                    <div className="col-4 text-end">
                      <div className="head-icons">
                        <Link
                          to={route.ProposalsGrid}
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          data-bs-original-title="Refresh"
                        >
                          <i className="ti ti-refresh-dot" />
                        </Link>
                        <Link
                          to="#"
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          data-bs-original-title="Collapse"
                          id="collapse-header"
                        >
                          <i className="ti ti-chevrons-up" />
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /Page Header */}
                {/* Card */}
                <div className="card">
                  <div className="card-header"></div>
                  <div className="card-body">
                    {/* Proposal Grid */}
                    <div className="row">
                      <div className="col-xxl-3 col-xl-4 col-md-6">
                        <div className="card border ">
                          <div className="card-body m-1">
                            <div className="d-block">
                              <div className="d-flex align-items-center justify-content-between mb-3">
                                <h3>102</h3>
                              </div>
                              <div className="mb-3">
                                <h3>
                                  Extension{" "}
                                  <div className="m-2">
                                    <i className="fa fa-users"></i>
                                  </div>
                                </h3>
                              </div>
                            </div>
                            <div className="bg-light-400 rounded p-2">
                              <div className="d-flex align-items-center justify-content-center">
                                <Link to="#" className="text-default">
                                  <h4 className="">
                                    Configuration{" "}
                                    <i className="fa fa-arrow-circle-right"></i>
                                  </h4>
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-xxl-3 col-xl-4 col-md-6">
                        <div className="card border">
                          <div className="card-body m-1">
                            <div className="d-block">
                              <div className="d-flex align-items-center justify-content-between mb-3">
                                <h3>34</h3>
                              </div>
                              <div className="mb-3">
                                <h3>
                                  Phone Number
                                  <div className="m-2">
                                    <i className="fa fa-phone"></i>
                                  </div>
                                </h3>
                              </div>
                            </div>
                            <div className="bg-light-400 rounded p-2">
                              <div className="d-flex align-items-center justify-content-center">
                                <Link to="#" className="text-default">
                                  <h4 className="">
                                    Configuration{" "}
                                    <i className="fa fa-arrow-circle-right"></i>
                                  </h4>
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-xxl-3 col-xl-4 col-md-6">
                        <div className="card border">
                          <div className="card-body m-1">
                            <div className="d-block">
                              <div className="d-flex align-items-center justify-content-between mb-3">
                                <h3>8</h3>
                              </div>
                              <div className="mb-3">
                                <h3>
                                  Welcome Message
                                  <div className="m-2">
                                    <i className="fa fa-message"></i>
                                  </div>
                                </h3>
                              </div>
                            </div>
                            <div className="bg-light-400 rounded p-2">
                              <div className="d-flex align-items-center justify-content-center">
                                <Link to="#" className="text-default">
                                  <h4 className="">
                                    Configuration{" "}
                                    <i className="fa fa-arrow-circle-right"></i>
                                  </h4>
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-xxl-3 col-xl-6 col-lg-6 col-md-6 col-sm-12">
                        <div className="card border">
                          <div className="card-body m-1">
                            <div className="d-block">
                              <div className="d-flex align-items-center justify-content-between mb-3">
                                <h3>102</h3>
                              </div>
                              <div className="mb-3">
                                <h3>
                                  Welcome Msg Options
                                  <div className="m-2">
                                    <i className="fa fa-message"></i>
                                  </div>
                                </h3>
                              </div>
                            </div>
                            <div className="bg-light-400 rounded p-2">
                              <div className="d-flex align-items-center justify-content-center">
                                <Link to="#" className="text-default">
                                  <h4 className="">
                                    Configuration{" "}
                                    <i className="fa fa-arrow-circle-right"></i>
                                  </h4>
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-xxl-3 col-xl-4 col-md-6">
                        <div className="card border">
                          <div className="card-body m-1">
                            <div className="d-block">
                              <div className="d-flex align-items-center justify-content-between mb-3">
                                <h3>3</h3>
                              </div>
                              <div className="mb-3">
                                <h3>
                                  Holidays
                                  <div className="m-2">
                                    <i className="fa fa-phone"></i>
                                  </div>
                                </h3>
                              </div>
                            </div>
                            <div className="bg-light-400 rounded p-2">
                              <div className="d-flex align-items-center justify-content-center">
                                <Link to="#" className="text-default">
                                  <h4 className="">
                                    Configuration{" "}
                                    <i className="fa fa-arrow-circle-right"></i>
                                  </h4>
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-xxl-3 col-xl-4 col-md-6">
                        <div className="card border">
                          <div className="card-body m-1">
                            <div className="d-block">
                              <div className="d-flex align-items-center justify-content-between mb-3">
                                <h3>7</h3>
                              </div>
                              <div className="mb-3">
                                <h3>
                                  Call Timing
                                  <div className="m-2">
                                    <i className="fa fa-mobile"></i>
                                  </div>
                                </h3>
                              </div>
                            </div>
                            <div className="bg-light-400 rounded p-2">
                              <div className="d-flex align-items-center justify-content-center">
                                <Link to="#" className="text-default">
                                  <h4 className="">
                                    Configuration{" "}
                                    <i className="fa fa-arrow-circle-right"></i>
                                  </h4>
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-xxl-3 col-xl-4 col-md-6">
                        <div className="card border">
                          <div className="card-body m-1">
                            <div className="d-block">
                              <div className="d-flex align-items-center justify-content-between mb-3">
                                <h3>6</h3>
                              </div>
                              <div className="mb-3">
                                <h3>
                                  E-mail Configuration{" "}
                                  <div className="m-2">
                                    <i className="fa fa-envelope"></i>
                                  </div>
                                </h3>
                              </div>
                            </div>
                            <div className="bg-light-400 rounded p-2">
                              <div className="d-flex align-items-center justify-content-center">
                                <Link to="#" className="text-default">
                                  <h4 className="">
                                    Configuration{" "}
                                    <i className="fa fa-arrow-circle-right"></i>
                                  </h4>
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-xxl-3 col-xl-4 col-md-6">
                        <div className="card border">
                          <div className="card-body m-1">
                            <div className="d-block">
                              <div className="d-flex align-items-center justify-content-between mb-3">
                                <h3>17</h3>
                              </div>
                              <div className="mb-3">
                                <h3>
                                  Disposition
                                  <div className="m-2">
                                    <i className="fa fa-tasks"></i>
                                  </div>
                                </h3>
                              </div>
                            </div>
                            <div className="bg-light-400 rounded p-2">
                              <div className="d-flex align-items-center justify-content-center">
                                <Link to="#" className="text-default">
                                  <h4 className="">
                                    Configuration{" "}
                                    <i className="fa fa-arrow-circle-right"></i>
                                  </h4>
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-xxl-3 col-xl-4 col-md-6">
                        <div className="card border">
                          <div className="card-body m-1">
                            <div className="d-block">
                              <div className="d-flex align-items-center justify-content-between mb-3">
                                <h3>50</h3>
                              </div>
                              <div className="mb-3">
                                <h3>
                                  Campaigns
                                  <div className="m-2">
                                    <i className="fa fa-users"></i>
                                  </div>
                                </h3>
                              </div>
                            </div>
                            <div className="bg-light-400 rounded p-2">
                              <div className="d-flex align-items-center justify-content-center">
                                <Link to="#" className="text-default">
                                  <h4 className="">
                                    Configuration{" "}
                                    <i className="fa fa-arrow-circle-right"></i>
                                  </h4>
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-xxl-3 col-xl-4 col-md-6">
                        <div className="card border">
                          <div className="card-body m-1">
                            <div className="d-block">
                              <div className="d-flex align-items-center justify-content-between mb-3">
                                <h3>30</h3>
                              </div>
                              <div className="mb-3">
                                <h3>
                                  Labels
                                  <div className="m-2">
                                    <i className="fa fa-tags"></i>
                                  </div>
                                </h3>
                              </div>
                            </div>
                            <div className="bg-light-400 rounded p-2">
                              <div className="d-flex align-items-center justify-content-center">
                                <Link to="#" className="text-default">
                                  <h4 className="">
                                    Configuration{" "}
                                    <i className="fa fa-arrow-circle-right"></i>
                                  </h4>
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-xxl-3 col-xl-4 col-md-6">
                        <div className="card border">
                          <div className="card-body m-1">
                            <div className="d-block">
                              <div className="d-flex align-items-center justify-content-between mb-3">
                                <h3>83</h3>
                              </div>
                              <div className="mb-3">
                                <h3>
                                  List
                                  <div className="m-2">
                                    <i className="fa fa-list"></i>
                                  </div>
                                </h3>
                              </div>
                            </div>
                            <div className="bg-light-400 rounded p-2">
                              <div className="d-flex align-items-center justify-content-center">
                                <Link to="#" className="text-default">
                                  <h4 className="">
                                    Configuration{" "}
                                    <i className="fa fa-arrow-circle-right"></i>
                                  </h4>
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-xxl-3 col-xl-4 col-md-6">
                        <div className="card border">
                          <div className="card-body m-1">
                            <div className="d-block">
                              <div className="d-flex align-items-center justify-content-between mb-3">
                                <h3>3</h3>
                              </div>
                              <div className="mb-3">
                                <h3>
                                  Email Templates
                                  <div className="m-2">
                                    <i className="fa fa-envelop"></i>
                                  </div>
                                </h3>
                              </div>
                            </div>
                            <div className="bg-light-400 rounded p-2">
                              <div className="d-flex align-items-center justify-content-center">
                                <Link to="#" className="text-default">
                                  <h4 className="">
                                    Configuration{" "}
                                    <i className="fa fa-arrow-circle-right"></i>
                                  </h4>
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-xxl-3 col-xl-4 col-md-6">
                        <div className="card border">
                          <div className="card-body m-1">
                            <div className="d-block">
                              <div className="d-flex align-items-center justify-content-between mb-3">
                                <h3>1</h3>
                              </div>
                              <div className="mb-3">
                                <h3>
                                  Text Template
                                  <div className="m-2">
                                    <i className="fa fa-mobile"></i>
                                  </div>
                                </h3>
                              </div>
                            </div>
                            <div className="bg-light-400 rounded p-2">
                              <div className="d-flex align-items-center justify-content-center">
                                <Link to="#" className="text-default">
                                  <h4 className="">
                                    Configuration{" "}
                                    <i className="fa fa-arrow-circle-right"></i>
                                  </h4>
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-xxl-3 col-xl-4 col-md-6">
                        <div className="card border">
                          <div className="card-body m-1">
                            <div className="d-block">
                              <div className="d-flex align-items-center justify-content-between mb-3">
                                <h3>5</h3>
                              </div>
                              <div className="mb-3">
                                <h3>
                                  Marketing Campaigns
                                  <div className="m-2">
                                    <i className="fa fa-users"></i>
                                  </div>
                                </h3>
                              </div>
                            </div>
                            <div className="bg-light-400 rounded p-2">
                              <div className="d-flex align-items-center justify-content-center">
                                <Link to="#" className="text-default">
                                  <h4 className="">
                                    Configuration{" "}
                                    <i className="fa fa-arrow-circle-right"></i>
                                  </h4>
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* /Proposal Grid */}
                  </div>
                </div>
                {/* /Card */}
              </div>
            </div>
          </div>
        </div>
        {/* /Page Wrapper */}
      </>
    </div>
  );
};

export default FlashPanel;
